import request from '@/utils/request'

export function fetchList(query) {
  return request({
    url: '/publicaccountad/list',
    method: 'get',
    params: query
  })
}

export function createPublicAccountAd(data) {
  return request({
    url: '/publicaccountad/create',
    method: 'post',
    data
  })
}

export function delPublicAccountAd(data) {
  return request({
    url: '/publicaccountad/del',
    method: 'post',
    data
  })
}

export function editStatus(data) {
  return request({
    url: '/publicaccountad/status',
    method: 'post',
    data
  })
}

export function editSort(data) {
  return request({
    url: '/publicaccountad/sort',
    method: 'post',
    data
  })
}
